import React, { useEffect, useState } from "react";
import jobData from "../../data/staff.json";
import "./JobSpecific.css";

const JobSpecific = ({ jobId, isAlbanian, lenis }) => {
  const [jobDetails, setJobDetails] = useState(null);
  const [messageBox, setMessageBox] = useState({ visible: false, message: "" });

  useEffect(() => {
    if (!jobId || jobData.length === 0) return;

    const foundProject = jobData.find(
      (p) => String(p.staff_id) === String(jobId)
    );

    if (foundProject) {
      setJobDetails(foundProject);
    } else {
      console.error(`Job with ID ${jobId} not found`);
    }
  }, [jobId]);


  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    cvUrl: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({ ...prevData, cvUrl: e.target.files[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simuluam suksesin lokalish
    setMessageBox({ 
      visible: true, 
      message: isAlbanian ? "Aplikimi u dërgua me sukses!" : "Application sent successfully!" 
    });

    // Resetojmë formën
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      cvUrl: null,
    });
  };

  const closeMessageBox = () => {
    setMessageBox({ visible: false, message: "" });
  };

  if (!jobDetails) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="jobspecific-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="jobspecific-content">
            <div className="jobspecific-left">
              <div
                className="jobspecific-title"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {isAlbanian ? jobDetails.titulli_staf : jobDetails.staff_title}
              </div>
            </div>
            <div className="jobspecific-right">
              <h2 data-aos="fade-up" data-aos-duration="1000">
                <strong>
                  {isAlbanian
                    ? `Përshkrimi i punës ${jobDetails.titulli_staf}`
                    : `Job description ${jobDetails.staff_title}`}
                </strong>
                <br />
                <br />
                {isAlbanian
                  ? jobDetails.pershkrimi_staf_dy
                      ?.split("\n")
                      .map((line, index) => (
                        <React.Fragment key={index}>
                          <p>{line}</p>
                        </React.Fragment>
                      ))
                  : jobDetails.staff_description_two
                      ?.split("\n")
                      .map((line, index) => (
                        <React.Fragment key={index}>
                          <p>{line}</p>
                          <p>&nbsp;</p>
                        </React.Fragment>
                      ))}
                <br />
                <br />
              </h2>
            </div>
          </div>
          <div className="job-application-form-container">
            <div className="job-application-form-first">
              <h3>
                {isAlbanian
                  ? "Apliko për këtë pozicion"
                  : "Apply for this position"}
              </h3>
            </div>
            <div className="job-application-form-second">
              <div className="job-application-form-red-card-select">
                <h1>Vila-L Group</h1>
                <p>Adresa: Rr.Teodor Keko, Tiranë</p>
                <p>
                  {isAlbanian ? "Numër Telefoni :" : "Phone number :"}
                  <br />
                  +355 68 200 0187
                </p>
              </div>
              <form onSubmit={handleSubmit} className="job-application-form">
                <div className="job-application-form-group">
                  <label htmlFor="firstName">
                    {isAlbanian ? "Emri" : "First Name"}
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="job-application-form-group">
                  <label htmlFor="lastName">
                    {isAlbanian ? "Mbiemri" : "Last Name"}
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="job-application-form-group">
                  <label htmlFor="email">
                    {isAlbanian ? "Emaili" : "Email"}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="job-application-form-group">
                  <label htmlFor="contactNumber">
                    {isAlbanian ? "Numër kontakti" : "Contact number"}
                  </label>
                  <input
                    type="text"
                    id="contactNumber"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="job-application-form-group">
                  <label htmlFor="cv">
                    {isAlbanian ? "Bashkëngjit CV" : "Upload a CV"}
                  </label>
                  <input
                    type="file"
                    id="cv"
                    name="cv"
                    accept=".pdf"
                    onChange={handleFileChange}
                    required
                  />
                </div>
                <div className="job-application-button-postion">
                  <button
                    type="submit"
                    className="job-application-submit-button"
                  >
                    {isAlbanian ? "APLIKO" : "APPLY"}
                  </button>
                </div>
              </form>
              {messageBox.visible && (
                <div className="job-application-message-box">
                  <p>{messageBox.message}</p>
                  <button onClick={closeMessageBox}>
                    {isAlbanian ? "Mbyll" : "Close"}
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default JobSpecific;
